import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "feedback-page"
};
const _hoisted_2 = {
  class: "text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_image = _resolveComponent("el-image");
  const _component_RemoveFilled = _resolveComponent("RemoveFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "feedback-title"
  }, [_createElementVNode("h3", {
    class: "feedback-title-font"
  }, "Help&Feedback")], -1)), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "describe"
  }, [_createElementVNode("small", {
    class: "feedback-contont-font"
  }, "Please leave us a message and we will reply you as soon as possible.")], -1)), _createVNode(_component_el_form, {
    ref: "feedbackForm",
    model: $data.feedbackForm,
    rules: $data.rules,
    "label-width": "120px",
    "label-position": "top",
    size: $options.elformSize
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "Questions or Suggestions",
      prop: "desc"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.feedbackForm.desc,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.feedbackForm.desc = $event),
        type: "textarea",
        autosize: {
          minRows: 4,
          maxRows: 10
        },
        placeholder: "What problem did you encounter？"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "What phone model and browser are you using？"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.feedbackForm.phoneInfo,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.feedbackForm.phoneInfo = $event),
        placeholder: "such as ：iphonXR Sarafi Or Samsung Chrome"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "How to contact you",
      prop: "contact"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.feedbackForm.contact,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.feedbackForm.contact = $event),
        placeholder: "such as ：smile@gmail.com"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules", "size"]), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("p", {
    class: "feedback-contont-font"
  }, "Images", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgs, (o, j) => {
    return _openBlock(), _createElementBlock("div", {
      key: j,
      class: "feedback-img-container"
    }, [_createVNode(_component_el_image, {
      class: "feedback-img",
      src: o.url,
      fit: "contain"
    }, null, 8, ["src"]), _createVNode(_component_el_icon, {
      class: "img-delete",
      onClick: $event => $options.handleDeleteImg(j)
    }, {
      default: _withCtx(() => [_createVNode(_component_RemoveFilled)]),
      _: 2
    }, 1032, ["onClick"])]);
  }), 128)), _createElementVNode("div", {
    class: "feedback-img-container",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.handleSelectImg && $options.handleSelectImg(...args))
  }, [_createVNode(_component_el_icon, {
    class: "uploader-img-but"
  }, {
    default: _withCtx(() => [_createVNode(_component_Plus)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    size: $options.elformSize,
    type: "primary",
    onClick: _cache[4] || (_cache[4] = $event => $options.submitForm())
  }, {
    default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("Submit")])),
    _: 1
  }, 8, ["size"])])])), [[_directive_loading, $data.loading]]);
}